import BlockUspList from './uspList'

export default BlockUspList
